export default __webpack_public_path__ + "static/media/DtVnJx26TKEr37c9aBBx_kwLzg38pQhM.cd098ea0.woff2";